export { instalarSrcNext } from './instalar-src-next'
export type { DependenciasSrcNext } from './dependencias-src-next'
export { prepararObservabilidade, ativarObservabilidade } from './observabilidade'
